<template>
    <section class="w-screen h-screen fixed flex inset-0 justify-center items-center z-50">
        <!-- Backdrop -->
        <div v-if="showModal" class="absolute inset-0 bg-black bg-opacity-50" @click="closeModal"></div>
        <div id="modal modal-customer" class="modal absolute block w-5/12 bg-white shadow-md rounded-lg" :class="{
            'animate__animated animate__zoomIn': showModal,
            'animate__animated animate__zoomOut': !showModal,
        }">
            <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Order</h5>
            </div>
            <div id="modal-body" class="p-5">
                <InputText v-model="customerName" id="customer-name" label="Customer Name" input_class="w-full" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="closeModal" />
                    <a href="/order"
                        class="block border shadow-sm rounded-md px-5 font-medium py-2 mx-1 bg-color-1 hover:bg-color-2 text-color-4">
                        Order
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';

export default {
    name: "ModalCardTable",
    components: {
        // Add any components used in the template
        InputText, SubmitButton
    },
    data() {
        return {
            customerName: '',
            showModal: true,
        };
    },
    methods: {
        closeModal() {
            this.showModal = false;
            setTimeout(() => {
                this.$emit('closeModal');
            }, 200);
        }
    },
};
</script>